module.exports = __webpack_public_path__ + "assets/ced14a3875acf1f57489edb4f28e79e8.png";